<template>
  <el-scrollbar style="height: 100%;">
    <div style="margin-bottom:20px">
      <el-page-header @back="goBack" title="返回" content></el-page-header>
    </div>
    <div style="width:50%;padding-left:4%">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="角色名称:" prop="name">
          <el-input v-model="form.name" maxlength="16" placeholder="2-16个字，支持中文、英文、数字"></el-input>
        </el-form-item>
        <el-form-item prop="description" label="描述:">
          <el-input
            v-model="form.description"
            placeholder="请输入描述"
            maxlength="400"
            type="textarea"
            rows="2"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色类型:">
          <el-select v-model="form.roleType" placeholder="请选择">
            <el-option
              v-for="(item,i) in roleTypeList"
              :label="item.roleTypeName"
              :value="item.id"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <div class="subtitle">
        <h4>角色权限配置</h4>
      </div>
      <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-if="form.roleType === '1'" label="系统管理权限" name="first">
            <sys-auth :sysData="sysData"></sys-auth>
          </el-tab-pane>
          <!-- <el-tab-pane v-if="showWb" label="坐席工作台权限" name="second">
            <wb-auth :wbData="wbData"></wb-auth>
          </el-tab-pane> -->
          <el-tab-pane v-if="computeApptab" label="应用权限" name="third">
            <app-auth></app-auth>
          </el-tab-pane>
        </el-tabs>
      </div>
      <el-row type="flex" justify="center" style="padding-bottom: 20px">
        <el-button @click="calcel()">取 消</el-button>
        <el-button
          type="primary"
          v-if="$authUtis.hasButtonAuth('aicc-bp', '/role/editRole_post')"
          @click="confirm()"
          :loading="comfirmBtnLoading"
        >确 认</el-button>
      </el-row>
    </el-row>
  </el-scrollbar>
</template>

<script>
import { listRoleType, getRolePermission, addRole, getRoleById, addAppRole, kickUser } from '@/api/user'
import SysAuth from './sysAuth/index'
import WbAuth from './wbAuth/index'
import AppAuth from './appAuth/index'
import { mapActions } from 'vuex'
export default {
  name: 'EditRole',
  data() {
    return {
      form: {
        id: '',
        name: '',
        description: '',
        roleType: ''
      },
      comfirmBtnLoading: false,
      rules: {
        name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' },
          { min: 2, max: 16, message: '须为2-16位中文、英文、数字', trigger: 'blur' },
          {
            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/,
            message: '仅支持中文、英文、数字',
            trigger: 'blur'
          }
        ],
        description: [
          { required: true, message: '请输入描述', trigger: 'blur' }
        ]
      },
      roleTypeList: [],
      activeName: 'first',
      sysData: [],
      wbData: []
    }
  },
  props: {
    listRoleFlag: Boolean
  },
  components: {
    SysAuth,
    AppAuth,
    WbAuth
  },
  mounted() {
    // 进入页面先清除权限缓存
    this.$store.commit('role/setCurAddWbAuthData', [])
    this.$store.commit('role/setCurAddSysAuthData', [])
    // 加载坐席组和技能组数据
    this._getUserGroupTree({ type: '0' })
    this._listSkillGroup()

    this._listRoleType()
    // 初始时先加载
    this._getRolePermission('0', this.storeRoleId, 'aicc_bp')
    this._getRolePermission('0', this.storeRoleId, 'aicc_wb')
    /* if (this.storeRoleId) {//和_listRoleType()  有冲突
      this._getRoleById(this.storeRoleId)
    } */
  },
  computed: {
    storeRoleId() {
      return this.$store.state.role.roleId
    },
    storeAppList() {
      return this.$store.state.user.appList
    },
    computeApptab() {
      return this.form.roleType === '1' && this.storeAppList.length > 0
    }
  },
  watch: {
    storeRoleId(val) {
      this._getRolePermission('0', val, 'aicc_bp')
      this._getRolePermission('0', val, 'aicc_wb')
      this._getRoleById(val)
      this.curRoleId = val
    },
    'form.roleType'(val) {
      // this.$store.commit('role/setCurAddSysAuthData', { data: this.sysData })
      // this.$store.commit('role/setCurAddWbAuthData', { data: this.wbData })
      // this.$store.commit('role/setCurAppAuthData', { data: [] })
      this.sysData = this.$store.state.role.curAddSysAuthData
      this.wbData = this.$store.state.role.curAddWbAuthData
      if (val === '2') {
        this.activeName = 'second'
      } else {
        this.activeName = 'first'
      }
    }
  },
  methods: {
    ...mapActions('role', ['_listSkillGroup', '_listRoles']),
    ...mapActions('user', ['_getUserGroupTree']),
    showWb() {
      return this.form.roleType === '1' || this.form.roleType === '2'
    },
    _listRoleType() {
      listRoleType().then(res => {
        if (res.code === 2000) {
          this.roleTypeList = res.data
          if (this.storeRoleId) {
            this._getRoleById(this.storeRoleId)
          } else {
            this.form.roleType = res.data[0].id
          }
        }
      })
    },
    _getRolePermission(queryType, roleId, app) {
      getRolePermission({ queryType, roleId, app, containApp: false })
        .then(res => {
          if (app === 'aicc_bp') {
            this.sysData = res.data
            this.$store.commit('role/setCurAddSysAuthData', res.data)
          } else if (app === 'aicc_wb') {
            this.wbData = res.data
            this.$store.commit('role/setCurAddWbAuthData', res.data)
          }
        })
        .catch(() => {})
    },
    _getRoleById(id) {
      getRoleById(id)
        .then(res => {
          this.form.id = res.data.id
          this.form.name = res.data.roleName
          this.form.description = res.data.description
          this.form.roleType = res.data.roleType
        })
        .catch(() => {})
    },
    changeView() {
      this.$emit('changeView', !this.listRoleFlag)
    },
    goBack() {
      this.changeView()
    },
    confirm() {
      this.$refs.form.validate(valid => {
        this.comfirmBtnLoading = true
        // 表单校验通过,提交到后端
        if (valid) {
          // 保存
          if (this.form.roleType === '1') {
            this.form.sysAuth = this.$store.state.role.curAddSysAuthData
          } else if (this.form.roleType === '2') {
            this.form.sysAuth = []
          }
          this.form.wbAuth = this.$store.state.role.curAddWbAuthData
          this.form.appAuth = this.$store.state.role.curAppAuthData
          if (this.$store.state.role.roleId) {
            this.$confirm('角色权限修改变动后，角色对应账号将被强制下线，请您确认是否需要继续修改？', {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              showClose: false
            }).then(() => {
              this.remoteSave()
              this.comfirmBtnLoading = false
            }).catch(() => {
              this.comfirmBtnLoading = false
            })
          } else {
            this.remoteSave()
            this.comfirmBtnLoading = false
          }
        } else {
          this.comfirmBtnLoading = false
          // 表单校验不通过,驳回重新填写
          return false
        }
      })
    },
    remoteSave() {
      // 校验系统管理权限和应用权限至少勾选一项
      if (!this.checkSelectMenu()) {
        this.$message.warning('请勾选权限!')
        return
      }
      addRole(this.form).then(res => {
        if (res.code === 2000) {
          const roleId = res.data
          if (roleId) {
            this._listRoles()
            // 保存app权限
            if (this.storeAppList.length > 0) {
              this.form.appAuth.forEach((v, i) => {
                const obj = {}
                obj.roleId = roleId
                obj.app = v.name
                obj.data = v.data
                addAppRole(obj).then(res => {
                // TODO判断调用APP接口是否调用成功
                })
              })
            }
            /** 踢出用户 */
            kickUser({ roleId }).then(res => {
              if (res.code === 2000) {
                this.$message.success('保存成功!')
                this.changeView()
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    checkSelectMenu() {
      if (this.form.roleType === '1') {
        // 校验系统管理权限和应用权限至少勾选一项
        let f = false
        if (!this.selectedMenu(this.form.sysAuth)) {
          if (this.form.appAuth.length && this.form.appAuth.length > 0) {
            for (let i = 0; i < this.form.appAuth.length; i++) {
              const data = this.form.appAuth[i]
              if (this.selectedMenu(data)) {
                f = true
                break
              }
            }
          }
        } else {
          f = true
        }
        return f
      } else if (this.form.roleType === '2') {
        // 校验坐席工作台权限
        return this.selectedMenu(this.form.wbAuth)
      }
    },
    /**
     * 勾选了返回true，没有勾选返回false
     */
    selectedMenu(data) {
      if (data instanceof Array) {
        return this.recCheckValue(data)
      } else {
        return this.recCheckValue(data.data)
      }
    },
    recCheckValue(menu) {
      const f = false
      for (let i = 0; i < menu.length; i++) {
        const element = menu[i]
        if (element.value) {
          if (element.value === 'true') {
            return true
          } else if (element.children && element.children.length && element.children.length > 0) {
            const temp = this.recCheckValue(element.children)
            if (temp) {
              return temp
            }
          }
        }
      }
      return f
    },
    calcel() {
      this.changeView()
    },
    handleClick() {}
  }
}
</script>
<style lang="scss" scoped>
.subtitle {
  margin-top: 20px;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e1e3e6;
}
.el-tabs {
  margin-bottom: 20px;
}
.el-button + .el-button {
  margin-left: 30px;
}
</style>
